import React from 'react';
import { Link } from 'gatsby';
import PropTypes from 'prop-types';
import { Container, Row, Column, List } from '@pella/sash-framework';
import { CTA } from '../../../../../';

const PerformanceMenu = ({ data, ...other }) => (
	<div
		className='performanceMenu max-h-[calc(100vh-150px)] overflow-auto bg-gray-3 py-9'
		aria-label='Sub Navigation'
		{...other}
	>
		<Container>
			<Row className={`xl:-mx-10 xl:pl-11 3xl:pl-20 xl:[&>div]:px-10`}>
				{data.category.map((resource, index) => (
					<Column
						key={index}
						xl='auto'
					>
						{resource.heading && (
							resource.direct_link ? (
								<Link
									className='no-underline'
									to={resource.direct_link}
								>
									<p className='text-sm uppercase text-gray-40'>{resource.heading}</p>
								</Link>
							) : (
								<p className='text-sm uppercase text-gray-40'>{resource.heading}</p>
							)
						)}
						
						<List bullets='none'>
							{resource.entries.map((item, index) => (
								<li
									key={index}
									className='my-2 leading-snug'
								>
									<CTA
										data={item}
										className='inline-block text-sm font-semibold decoration-transparent decoration-1 hover:decoration-current focus:decoration-current'
										renderAs='link'
									/>
								</li>
							))}
						</List>
					</Column>
				))}
			</Row>
		</Container>
	</div>
);

PerformanceMenu.propTypes = {
	data: PropTypes.object,
};

export default PerformanceMenu;
